<template>
  <Page>
    <div class="flex flex-col items-center justify-center py-12">
      <p class="text-sm text-text-light">Redirecting to create Bill of Material...</p>
    </div>
  </Page>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Page from '@/shared/components/layouts/Page.vue';

definePage({
  meta: {
    title: 'Add Bill of Material',
  },
});

const router = useRouter();

onMounted(() => {
  void router.replace({
    name: '/spares/billofmaterials/[billOfMaterialId]',
    params: { billOfMaterialId: 'new' },
  });
});
</script>
